function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_483",
  "data-name": "Group 483",
  transform: "translate(-531 -6674)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_145",
  "data-name": "Rectangle 145",
  width: 38,
  height: 25,
  transform: "translate(531 6674)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_337",
  "data-name": "Group 337",
  transform: "translate(439.289 6667.638)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_335",
  "data-name": "Group 335",
  transform: "translate(110.608 13.089)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_64",
  "data-name": "Rectangle 64",
  width: 17.74,
  height: 11.573,
  fill: "#cb0027"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_336",
  "data-name": "Group 336",
  transform: "translate(92.87 13.123)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_65",
  "data-name": "Rectangle 65",
  width: 17.738,
  height: 11.539,
  fill: "#fff"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_66",
  "data-name": "Rectangle 66",
  width: 35.482,
  height: 5.742,
  transform: "translate(92.866 7.362)",
  fill: "#00123e"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_67",
  "data-name": "Rectangle 67",
  width: 35.482,
  height: 5.771,
  transform: "translate(92.866 24.629)",
  fill: "#00123e"
})));

var SvgHomeFlag = function SvgHomeFlag(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHomeFlag, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/homeFlag.9576cbc5.svg";
export { ForwardRef as ReactComponent };